import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  withCredentials: true
});

export const getDoctorPatients = async ({
  limit = 20,
  offset = 0,
  q = '',
  snapshot = 'all'
} = {}) => {
  const response = await api.get('/doctor/patients', {
    params: {
      limit,
      offset,
      q,
      snapshot
    }
  });
  return response.data;
};

export const getDoctorPatientClinicalChart = async (
  patientId,
  {
    visitLimit = 30,
    historyLimit = 10
  } = {}
) => {
  const response = await api.get(`/doctor/patients/${patientId}/clinical-chart`, {
    params: {
      visit_limit: visitLimit,
      history_limit: historyLimit
    }
  });
  return response.data;
};
